// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.typing-dot[data-v-7d6c01d7] {
  display: inline-block;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background-color: #9ca3af;
  animation: typing-bounce-7d6c01d7 1.2s infinite ease-in-out;
}
.typing-dot[data-v-7d6c01d7]:nth-child(2) {
  animation-delay: 0.2s;
}
.typing-dot[data-v-7d6c01d7]:nth-child(3) {
  animation-delay: 0.4s;
}
@keyframes typing-bounce-7d6c01d7 {
0%,
  60%,
  100% {
    transform: translateY(0);
    opacity: 0.4;
}
30% {
    transform: translateY(-5px);
    opacity: 1;
}
}
.btn-shadow[data-v-7d6c01d7] {
  --tw-translate-y: -12px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1) !important;
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
  --tw-shadow-color: rgb(0 18 44 / 0.3) !important;
  --tw-shadow: var(--tw-shadow-colored) !important;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
